<template>
  <div>
    <vueMiniPlayer
      class="video-player"
      v-if="isIframe"
      ref="vueMiniPlayer"
      :key="videoUrl"
      :video="video"
      :mutex="true"
    />
    <iframe v-else :src="video.url" width="600" height="320"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="101_2"></iframe>
  </div>
</template>

<script>
export default {
  props:{
    videoUrl:{
      type:String,
      default:''
    }
  },
  watch:{
    videoUrl:{
      handler(val){
        if(val!=null){
          this.video.url = val
        }
      },
      deep:true,
      immediate:true
    }
  },
  computed:{
    isIframe(){ 
      return this.getIsIframe(this.video.url)
    }
  },
  data() {
    return {
      video: {
        url: null,
        cover: "",
        muted: false,
        loop: false,
        preload: "auto",
        poster: "",
        volume: 1,
        autoplay: false,
      },
    };
  },
  methods: {
    getIsIframe(val){
      let url =  val.match(/^(?:https?:\\)?(?:[^@\n]+@)?(?:www\.)?([^:\\n]+)/im)[1];
      return url.hostname  !==  process.env.VUE_APP_HOST_NAME
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep{
  .qun-base-controls{
    display: none;
  }
  ._play-btn{
    z-index: 100;
  }
}
</style>